import React, { Component } from "react";
import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import ImageMcDonalds_1 from "../images/realisations/projet_mcdonalds/1_MACDONALDS.jpg";
import ImageMcDonalds_2 from "../images/realisations/projet_mcdonalds/2_MACDONALDS.jpg";
import ImageMcDonalds_3 from "../images/realisations/projet_mcdonalds/3_MACDONALDS.jpg";
import ImageMcDonalds_4 from "../images/realisations/projet_mcdonalds/4_MACDONALDS.jpg";
import ImageMcDonalds_5 from "../images/realisations/projet_mcdonalds/5_MACDONALDS.jpg";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";


class RealisationMcDonalds extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="grid grid--2 grid--fixed"
          style={{ marginTop: "55px" }}
        >
          <LocalizedLink className="grid__item" to="/realisations">
            <div className="grid__item-title">
              <i className="f7 i-arrow-left-light" /> {this.props.t("common:realisationsBackbutton")}
            </div>
          </LocalizedLink>
          <div className="grid__item">
            <div className="grid__item-title-nohover font-bold">
              McDonald's Champs Elysées - Paris
            </div>
          </div>
        </section>

        <section className="projects">
          <div
            className="projects__item projects__item--100"
            style={{ backgroundImage: `url(${ImageMcDonalds_1})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelDesign")} : Studio Norguet -{" "}
              <span class="font-bold">
                Crédit photos : Photos Renaud Callebaut - Visuels des caissons
                lumineux réalisés par SND et Franck Hülsbömer
              </span>
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageMcDonalds_2})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelDesign")} : Studio Norguet - Crédit photos : Photos Renaud Callebaut
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageMcDonalds_3})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelDesign")} : Studio Norguet - Crédit photos : Photos Renaud Callebaut
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageMcDonalds_4})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelSurface")} : PurePaper - {surfacesByIds[2002]["title_"+this.props.lng]} {/*Skin - Pearl 011*/}
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageMcDonalds_5})` }}
          >
            <div className="projects__item-label">
            {this.props.t("common:labelPattern")} : {this.props.t("common:labelCollections55")} - {patternsByIds[33]["title_"+this.props.lng]}{" "}{/* Collections 5.5 - Crépitemente*/}
            </div>
          </div>
        </section>

        <section className="w-100 pv7">
          <div className="w-100 tc">

          <LocalizedLink className="button button--large" to="/realisations/eurojust-la-haye">
            <i className="button__icon i-arrow-left-light" />
            &nbsp;{this.props.t('common:labelPreviousProject')}
          </LocalizedLink>

          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <LocalizedLink className="button button--large" to="/create">
          {this.props.t('common:labelCreateYourModel')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>

          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <LocalizedLink className="button button--large" to="/realisations/mgm-casino">
            {this.props.t('common:labelNextProject')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>

          </div>
        </section>

          <Footer t={this.props.t} />
      </React.Fragment>
    );
  }
}

export default RealisationMcDonalds;



// WEBPACK FOOTER //
// ./src/components/RealisationMcDonalds.js